export type CountryType = 'NL' | 'SE';
export type LanguageType = 'en' | 'nl' | 'sv';

export enum Country {
  NL = 'NL',
  SE = 'SE',
}

export enum Language {
  EN = 'en',
  NL = 'nl',
  SV = 'sv',
}

const langToLocaleMap = {
  [Language.EN]: 'sv-SE', // Default to Swedish locale for English to get iso format
  [Language.NL]: 'nl-NL',
  [Language.SV]: 'sv-SE',
};

export const getLocaleIdByLanguage = (language: LanguageType) => {
  return langToLocaleMap[language] ?? langToLocaleMap[Language.SV];
};

export const isSweden = (country: CountryType) => country === Country.SE;
export const isNetherlands = (country: CountryType) => country === Country.NL;
